module.exports = __webpack_public_path__ + "static/media/2a2.39128161.jpg";